import { FormAccordion } from '@strata/react-form-section';
import { Spinner } from '@strata/react-loading-animation';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router';

import { type RawTransactions, useGetClaimRawTransactionsQuery } from 'store/api/medbillingApi';

const FormSections: {
    step: number;
    sectionTitle: string;
    key: keyof RawTransactions;
}[] = [
    { step: 1, sectionTitle: '999', key: 'raw999' },
    { step: 2, sectionTitle: '277 CA', key: 'raw277CA' },
    { step: 3, sectionTitle: 'CLAIM', key: 'rawInternalClaim' },
];

export const RawTransactionsTab = () => {
    const { payerId, transactionId } = useParams() as { payerId: string; transactionId: string };

    const { data: rawTransactions, isFetching } = useGetClaimRawTransactionsQuery({
        payerId,
        transactionId,
    });

    const [openSections, setOpenSections] = useState(
        Object.fromEntries(FormSections.map(({ step }) => [step, false])),
    );

    const sectionsWithData = useMemo(
        () =>
            FormSections.map((section) => {
                const rawData = rawTransactions?.[section.key];
                return {
                    ...section,
                    content: (
                        <pre style={{ margin: 0 }}>
                            {rawData?.map((row, i) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <div key={i}>{row}</div>
                            ))}
                        </pre>
                    ),
                    progressIndicatorStatus: rawData
                        ? FormAccordion.statuses.COMPLETED
                        : FormAccordion.statuses.NOT_STARTED,
                    onSectionClick: () =>
                        setOpenSections((prev) => ({
                            ...prev,
                            [section.step]: !prev[section.step],
                        })),
                    isOpen: openSections[section.step],
                    disabled: !rawData,
                };
            }),

        [openSections, rawTransactions],
    );

    return isFetching ? (
        <Spinner size={Spinner.Size.LARGE} className="margin__top--x-large" />
    ) : (
        <FormAccordion sectionDataArray={sectionsWithData} />
    );
};
